import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function JetMediaShuttleWorkflowLinking() {
    return (
        <React.Fragment>
            <p>To link a Media Shuttle portal to a Jet job:</p>
            <ol>
                <li>
                    In the Jet Administration Console,{' '}
                    <a href="/jet/administration/storage-profiles/overview">create a storage profile</a> on the SDCX
                    Server to use as a source folder.
                </li>
                <li>
                    In the Media Shuttle IT Administration Console, <strong>Assign</strong> the same SDCX Server as a
                    storage location for a Media Shuttle portal.
                </li>
                <li>
                    Configure the <strong>Path</strong> to match the storage profile directory created in the Jet
                    Administration Console.
                </li>
                <li>
                    Click <strong>Save Changes</strong>.
                </li>
                <li>
                    In the Jet Administration Console, <a href="/jet/jobs/working-with-jobs">create a job</a> using the
                    associated Media Shuttle storage profile.
                </li>
            </ol>
            <p>
                As files are transferred to and from Media Shuttle portals by portal members, Jet will determine when to
                send files to the receiving endpoint based on the job trigger type.
            </p>
        </React.Fragment>
    );
}

JetMediaShuttleWorkflowLinking.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(JetMediaShuttleWorkflowLinking);
